<template>
    <div class="root-layout">
        <!-- <div class="view-box"> -->
        <router-view />
        <div class="tab">
            <div class="tab_item" v-for="(item, index) in tabBarImg" :key="index" @click="switchToTab(item.path)">
                <img :src="$route.path === item.path ? item.icon : item.normal" alt="" />

                <span :class="$route.path === item.path ? 'active' : ''">{{ item.title }}</span>
            </div>
        </div>
        <!-- </div> class="no-data" -->
        <!-- <van-tabbar placeholder v-model="active" class="no-data" active-color="#288DEA" inactive-color="#333333" safe-area-inset-bottom>
            <van-tabbar-item replace to="/product" name="/product">
                <span>首页</span>
                <template #icon="props">
                    <img :src="props.active ? icon.active : icon.inactive" />
                </template>
            </van-tabbar-item>
            <van-tabbar-item replace to="/" name="/" icon="share-o">卡权益</van-tabbar-item>
            <van-tabbar-item replace to="/my" name="/my" icon="manager-o">我的</van-tabbar-item>
            
        </van-tabbar> -->
        <!-- <van-tabbar-item replace to="/comp" name="/comp" icon="search">组件</van-tabbar-item>
            <van-tabbar-item replace to="/http" name="/http" icon="friends-o">接口</van-tabbar-item>
            <van-tabbar-item replace to="/vuex" name="/vuex" icon="setting-o">Vuex</van-tabbar-item> -->
    </div>
</template>
<script>
export default {
    data() {
        return {
            active: '',
            tabBarImg: [
                {
                    path: '/',
                    normal: require('@/assets/tabBar/home.png'),
                    icon: require('@/assets/tabBar/ahome.png'),
                    title: '首页'
                },
                // {
                    
                //     path: '/product',
                //     normal: require('@/assets/tabBar/share.png'),
                //     icon: require('@/assets/tabBar/ashare.png'),
                //     title: '卡权益'
                // },
                {
                    path: '/my',
                    normal: require('@/assets/tabBar/me.png'),
                    icon: require('@/assets/tabBar/ame.png'),
                    title: '我的'
                }
            ]
        }
    },
    mounted() {
        // 默认高亮的导航栏目
        this.active = this.$route.path
    },
    methods: {
        switchToTab(path) {
            console.log(path)
            this.$router.replace(path)
        }
    }
}
</script>
<style lang="scss" scoped>
.tab {
    width: 100%;
    height: 98px;
    display: flex;
    border-top: 1px solid #ccc;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    z-index: 999;
    height: calc(98px + constant(safe-area-inset-bottom));
    height: calc(98px + env(safe-area-inset-bottom));
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
}
.tab_item {
    width: 100%;
    display: flex;
    color: #333333;;
    font-size: 20px;
    font-weight: 400;
    align-items: center;
    justify-content: space-around;
    flex-direction: column;
}
.tab_item img {
    width: 45px;
    height: 45px;
}
.active {
    color: #0A4238;
    font-weight: 400;
}
</style>